import React from 'react'
import logo from '../../assets/images/logo.png'
import { useDispatch } from "react-redux";
import { userLoggedOut } from "../../features/auth/authSlice";
import { Link , useLocation} from "react-router-dom";
import { useState } from "react";
import { searched } from '../../features/projects/projectsSlice';
import { useSelector } from "react-redux";
const Layout = ({children}) => {
    const { user: loggedInUser } = useSelector((state) => state.auth) || {};
    const dispatch = useDispatch();
    const location = useLocation();
    const { search } = useSelector((state) => state.project);
    const logout = () => {
        dispatch(userLoggedOut());
        localStorage.clear();
    };


    const onChangeHandler = (value)=>{
        dispatch(searched(value))
    }

    function debounce(func){
        let timer;
        return function (...args) {
          const context = this;
          if (timer) clearTimeout(timer);
          timer = setTimeout(() => {
            timer = null;
            func.apply(context, args);
          }, 500);
        };
    }

    const debounced = debounce(onChangeHandler)

  return (  
        <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
            <div className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
                <Link to="/">
                    <img src={logo} className="h-10 w-10" />
                </Link>
                <div className="ml-10">
                <Link to="/projects"><span className={`mx-2 text-sm font-semibold ${ location.pathname==='/projects' ? 'text-indigo-700': 'hover:text-indigo-700'}`} href="projects.html">Projects</span></Link>
                <Link to="/teams"><span className={`mx-2 text-sm font-semibold ${ location.pathname==='/teams' ? 'text-indigo-700': 'hover:text-indigo-700'}`} href="teams.html">Team</span></Link>
                </div>
                {location.pathname==='/projects' &&
                            // <form onSubmit={handleSubmit}>
                                <input
                                    className="outline-none border-none mr-2 mx-2 text-sm font-semibold rounded-full"
                                    type="search"
                                    name="search"
                                    placeholder="Search"
                                    onChange={(e) => debounced(e.target.value)}
                                />
                            // </form>
                }

                <button className="flex items-center justify-center w-8 h-8 ml-auto overflow-hidden rounded-full cursor-pointer">
                    <img src={loggedInUser && loggedInUser.image} alt=""/>

                </button>
                <span className="m-5 cursor-pointer f" onClick={logout}>
                    Logout
                </span>
            </div>

            {children}
        </div>
  )
}

export default Layout